import type { OpeningsUserPagePhoto } from "@/lib/api/openingsTypes";

import { photoEngagementMetadata } from "@/lib/api/photoEngagement";

/** The API sorts before limiting; preserve its order, including null positions. */
export const adaptMemberPortfolio = (
  photos: OpeningsUserPagePhoto[],
  memberName: string,
  salonId?: string,
) => photos.filter((photo) => photo.src).map((photo, index) => ({
  _id: photo.id,
  ...photoEngagementMetadata(photo, salonId),
  src: photo.src,
  alt: photo.alt || `${memberName} work photo ${index + 1}`,
  type: photo.type ?? "image",
  variants: Array.isArray(photo.variants)
    ? photo.variants.filter((variant): variant is string => typeof variant === "string")
    : [],
  portfolioOrder: photo.portfolioOrder,
}));
